<template>
    <modal width="60%" :title="$t(title)" :visible.sync="isShowDialog" :top="'8vh'">
        <div class="dialogClass">
            <div class="tabs">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane v-for="(item, index) in tabsArray" :key="item.type" :label="$t(item.label)" :name="item.type">
                        <template v-if="index !== 2">
                            <span slot="label">
                                <i class="el-icon-warning" :class="active === index ? 'active' : ''" v-show="active === index && $attrs.rowData.configStatus === 1"></i>
                                {{ $t(item.label) }}
                            </span>
                        </template>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 内容展示 keep-alive先放这里-->
            <keep-alive>
                <component ref="componentContent" v-bind="$attrs" :is="componentContent"></component>
            </keep-alive>
        </div>
    </modal>
</template>

<script>
import Net from './config/Net.vue'
import ConfigLogVue from './config/ConfigLog.vue'

export default {
  name: 'ConfigDialog',
  components: {
    ConfigNet: Net,
    config: ConfigLogVue
  },
  props: ['isShowConfig'],
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowConfig
      },
      set: function (val) {
        this.$emit('update:isShowConfig', val) // 可以优化成model  或者minx
      }
    }
  },
  data () {
    return {
      title: 'public.config_info',
      activeName: 'ConfigNet',
      tabsArray: [
        {
          type: 'ConfigNet',
          label: 'public.net_param'
        },
        {
          type: 'config',
          label: 'device.config_log'
        }
      ],
      componentContent: 'ConfigNet',
      loading: true,
      active: 0
    }
  },
  mounted () {},
  mounted () {},
  methods: {
    handleClick ({ name, index }) {
      this.active = parseInt(index)
      this.componentContent = name
    }
  }
}
</script>

<style lang="scss" scoped>
//@import '../../style/sensor.scss';

.active {
    color: red;
    margin-right: 5px;
}
</style>
